import { useIsMounted } from "@xapp/components";
import { LoadingSpinner } from "@xapp/components";
import { useGetUserProfileQuery, UserProfile } from "generated/graphql";
import React, { FC } from "react";

export interface FetchProfileComponentProps {
    /**
     * The newly obtained access token.
     */
    accessToken: string;
    /**
     * Sets the user profile when it was obtained.
     * @param profile
     */
    onProfile(profile: UserProfile): void;
    /**
     * Called when there was an error obtaining the user's profile.
     * @param error
     */
    onError(error: Error): void;
}

/**
 * Fetches a profile for you
 */
export const FetchProfileComponent: FC<FetchProfileComponentProps> = (props: FetchProfileComponentProps) => {

    const { accessToken, onProfile, onError } = props;
    const mounted = useIsMounted();

    // change this back!
    const [response] = useGetUserProfileQuery({
        requestPolicy: "network-only", // Only the latest and greatest
        variables: { jwt: accessToken }
    });

    const { data, error, fetching } = response;

    if (fetching) {
        return (
            <LoadingSpinner loadingText={"Fetching profile..."} />
        );
    }

    if (mounted()) {
        if (error) {
            onError(error);
        } else if (data && data.profile) {
            onProfile(data.profile);
        }
    }

    return (
        <LoadingSpinner loadingText={"Fetching profile..."} />
    );
};